import { FilesSvg } from './assets';
import { useFileDownloader } from './hooks';
import s from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const UploadFileReadOnly = ({ fileName, blockId, activityResponseId }) => {
  const { downloadUrl, downloadFileUrl, handleDownloadedUrl } =
    useFileDownloader();

  const handleDownload = async () => {
    await downloadFileUrl(blockId, activityResponseId);

    if (downloadUrl) {
      handleDownloadedUrl(downloadUrl, fileName);
    }
  };

  return (
    <div className={s.containerReadOnly}>
      <div>
        <FilesSvg />
      </div>
      <button onClick={handleDownload} className={s.linkedButton}>
        {fileName}
      </button>
    </div>
  );
};

export default UploadFileReadOnly;
